import type { GroupData, MemberData, NonMemberData } from "shared/schema";
import { renderMarkup } from "shelving";
import { JOIN_GROUP, LEAVE_GROUP } from "shared/api";
import { AsyncButton, Icon } from "shared/react";
import { NON_MEMBER } from "shared/schema";
import { ProfileButton } from "../entity/EntityButton.js";
import { callAPIWithNotice } from "../util/api.js";

export function GroupJoinPanel({ gid, group, member = NON_MEMBER }: { gid?: string; group: GroupData; member?: MemberData | NonMemberData | undefined }): React.ReactElement | null {
	const { approval } = group;
	const { status, why, updater } = member;
	return status === "blocked" ? (
		<aside className="panel">
			<p className="space-xsmall">Blocked from group:</p>
			<blockquote className="space-xsmall">{renderMarkup(why)}</blockquote>
		</aside>
	) : status === "invited" ? (
		<aside className="panel">
			<p className="space-xsmall">
				<ProfileButton uid={updater} /> invited you:
			</p>
			<p className="space-xsmall flex-row">
				<AsyncButton onClick={() => callAPIWithNotice(LEAVE_GROUP, gid)}>
					<Icon icon="close" /> <span>Ignore</span>
				</AsyncButton>
				<AsyncButton mods="button-default" onClick={() => callAPIWithNotice(JOIN_GROUP, gid)}>
					<Icon icon="tick" /> <span>Accept</span>
				</AsyncButton>
			</p>
		</aside>
	) : status === "pending" || status === "none" ? (
		<aside className="panel">
			{status === "pending" ? (
				<AsyncButton>
					<Icon icon="snooze" /> <span>Requested</span>
				</AsyncButton>
			) : (
				<AsyncButton onClick={() => callAPIWithNotice(JOIN_GROUP, gid)}>
					<Icon icon="chat" /> <span>{approval ? "Request to join" : "Join group"}</span>
				</AsyncButton>
			)}
		</aside>
	) : null;
}
